export const ADD_ARTICLE = "ADD_ARTICLE";
export const SET_SEARCH_WORD = "SET_SEARCH_WORD";
export const SET_ACTIVE_FILTERS = "SET_ACTIVE_FILTERS";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_FILTERS = "SET_FILTERS";
export const SET_RESULTS_COUNT = "SET_RESULTS_COUNT";
export const SET_MASTER_CATEGORIES = "SET_MASTER_CATEGORIES";
export const SET_SEARCH_URL = "SET_SEARCH_URL";
export const SET_DEFAULT_MASTER_CATEGORIES = "SET_DEFAULT_MASTER_CATEGORIES";
export const SET_SORT = "SET_SORT";
export const SET_PAGE = "SET_PAGE";
export const SET_PAGES = "SET_PAGES";
export const SET_SUGGESTED_WORDS = "SET_SUGGESTED_WORDS";
export const SET_DEFAULT_CATEGORIES = "SET_DEFAULT_CATEGORIES";
export const SET_FILTERS_NO_PRICE = "SET_FILTERS_NO_PRICE";
export const SET_DEFAULT_NO_CATEGORIES = "SET_DEFAULT_NO_CATEGORIES";
export const SET_SLIDER_VALUE = "SET_SLIDER_VALUE";
export const SET_SLIDER_VALUE_MIN_MAX = "SET_SLIDER_VALUE_MIN_MAX";
export const SET_CONFIG = "SET_CONFIG";
export const SET_IS_MOBILE = "SET_IS_MOBILE";
export const SET_SHOW_FILTERS = "SET_SHOW_FILTERS";
export const SET_WORDS_HISTORY = "SET_WORDS_HISTORY";
export const SET_IS_SEARCHING = "SET_IS_SEARCHING";
export const SET_IS_AUTOCOMPLETE_OPEN = "SET_IS_AUTOCOMPLETE_OPEN";
export const SET_SHOW_OVERLAY = "SET_SHOW_OVERLAY";
export const SET_PREV_PRODUCTS = "SET_PREV_PRODUCTS";
export const SET_LAST_UPDATE = "SET_LAST_UPDATE";
export const SET_FILTERS_NO_FILTER = "SET_FILTERS_NO_FILTER";
export const SET_ADVANCED_CUSTOMIZATION = "SET_ADVANCED_CUSTOMIZATION";
export const SET_URL_PREFIX = "SET_URL_PREFIX";
export const SET_IMG_PREFIX = "SET_IMG_PREFIX";
export const SET_AUTOCOMPLETE_OPTIONS = "SET_AUTOCOMPLETE_OPTIONS";
export const SET_AUTOCOMPLETE_CATEGORIES_OPTIONS = "SET_AUTOCOMPLETE_CATEGORIES_OPTIONS";
export const SET_IS_EXPANDED = "SET_IS_EXPANDED";
export const SET_IS_FROM_HALF_SCREEN = "SET_IS_FROM_HALF_SCREEN";
export const SET_ASYNC_DATA = "SET_ASYNC_DATA";
export const SET_LISTING_BANNER = "SET_LISTING_BANNER";
export const SET_URL_QUERY = "SET_URL_QUERY";
export const SET_URL_FILTERS = "SET_URL_FILTERS"
export const SET_SEO_SETTINGS = "SET_SEO_SETTINGS"